import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { IUserLibrary } from "@litres-libs/types";
import { addHydrateReducer } from "../../utils/hydrateReducer";

const initialState: IUserLibrary = {};

export const librarySlice = createSlice({
  name: "user/library",
  initialState,
  reducers: {
    setUserLibrary: (
      state: IUserLibrary,
      action: PayloadAction<IUserLibrary>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "user.library");
  },
});

export const { setUserLibrary } = librarySlice.actions;

export default librarySlice.reducer;
